<ng-container *ngIf="header; else noHeader">
  <app-header></app-header>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</ng-container>
<ng-template #noHeader>
  <router-outlet></router-outlet>
</ng-template>